module.exports = __webpack_public_path__ + "static/media/bombas-pe-03.77a04a02.jpeg";